import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import useAppContext from "./use-app-context";
import useScript from "./use-script";

export default function useAnalytics() {
  const {app: {environment, organization}, user} = useAppContext();
  const location = useLocation();
  const [loaded, setLoaded] = useState(false);
  const development = environment !== "production";

  useScript(development ? {} : {url: "https://www.google-analytics.com/analytics.js"});

  useEffect(() => {
    if(development) { return; }

    window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date; /* eslint-disable-line */
    window.ga("create", "UA-51748057-2", "auto");

    setLoaded(true);
  }, [development]);

  useEffect(() => {
    if(!loaded) { return; }

    window.ga("send", "pageview", {page: location.pathname});
  }, [loaded, location.pathname]);

  useEffect(() => {
    if(!loaded) { return; }
    if(!organization) { return; }

    window.ga("set", "appName", organization.subdomain);
  }, [loaded, organization]);

  useEffect(() => {
    if(!loaded) { return; }
    if(!user) { return; }

    window.ga("set", "&uid", user.id);
  }, [loaded, user]);
}
